import React from 'react';
import PropTypes from 'prop-types';

const PinIcon = ({ fill = 'currentColor', width = '24', height = '24', className = '' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16 12V4H17V2H7V4H8V12L6 14V16H11V22H13V16H18V14L16 12Z"
        fill={fill}
      />
    </svg>
  );
};

PinIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string
};

export default PinIcon;
